import React, { type ReactNode } from 'react';
export type HighlightTone = 'go' | 'stop' | 'info';
type HighlightSide = 'right' | 'left' | 'bottom' | 'bottom-end';
type HighlightProps = {
  tone: HighlightTone;
  tag?: string;
  side?: HighlightSide;
  className?: string;
  children: ReactNode;
};
export const highlightColors: Record<HighlightTone, string> = {
  go: '#16A34A',
  stop: '#DC2626',
  info: '#2563EB'
};
const SIDE_CLASS: Record<HighlightSide, string> = {
  right: 'left-[calc(100%_+_0.8cqw)] top-1/2 -translate-y-1/2',
  left: 'right-[calc(100%_+_0.8cqw)] top-1/2 -translate-y-1/2',
  bottom: 'left-[-0.35cqw] top-[calc(100%_+_0.7cqw)]',
  'bottom-end': 'right-[-0.35cqw] top-[calc(100%_+_0.7cqw)]'
};

/** Draws the guide's colored "click here / not this" box around part of a mockup. */
export function Highlight({
  tone,
  tag,
  side = 'right',
  className = '',
  children
}: HighlightProps) {
  const color = highlightColors[tone];
  return <div className={`relative ${className}`} data-id="element-98" data-mp="sqedhn8fzofj">
      {children}
      <span className="pointer-events-none absolute -inset-[0.35cqw] border-[0.2cqw]" style={{
      borderColor: color
    }} aria-hidden="true" data-id="element-99" data-mp="21hso1l5hyj0t" />
      {tag ? <span className={`absolute z-10 whitespace-nowrap px-[0.5cqw] py-[0.15cqw] font-heading text-[1.05cqw] font-bold leading-[1.3] text-white ${SIDE_CLASS[side]}`} style={{
      backgroundColor: color
    }} data-id="element-100" data-mp="2aj074vzfzdab">
          {tag}
        </span> : null}
    </div>;
}